<!--  -->
<template>
	<div class="container" >
		<div class="search-container tr" ref="tableHeight" v-show="isEdit">
			<img class="icon-img" src="@/assets/images/disable.png" @click="updateStatusRow(1)" title="停用" alt="">
			<img class="icon-img ml7" src="@/assets/images/enable.png" @click="updateStatusRow(0)" title="启用" alt="">
			<img class="icon-img ml7" src="@/assets/images/delete.png" @click="deleteRow" title="删除" alt="">
			<img class="icon-img ml7" src="@/assets/images/add.png" @click="handleAdd" title="新增" alt="">
		</div>
		<!-- style="width: 99%" -->
		<div class="table-container" :style="{height:height+'px'}">
			<el-table ref="multipleTable" :data="tableData" :row-class-name="tabRowClassName" :cell-style="cellStyle"
				:header-cell-style="{background:'rgba(200, 204, 215,.6)',color:'#333333'}" border style="width: 100%;"
				:show-overflow-tooltip="true" @selection-change="handleSelectionChange" @cell-click="handleEdit">
				<el-table-column type="selection" width="50" align="center">
				</el-table-column>
				<el-table-column prop="skuName" label="SKU名称" sortable>
				</el-table-column>
				<el-table-column prop="skuFullName" label="SKU全称" sortable>
				</el-table-column>
				<el-table-column prop="skuCode" label="SKU编码" sortable>
				</el-table-column>
				<el-table-column prop="sapNo" label="SAP编号" sortable>
				</el-table-column>
				<el-table-column prop="barcode" label="条码" sortable>
				</el-table-column>
				<el-table-column label="规格"  prop="format">
					<template slot-scope="scope">
						<div>{{ scope.row.format }}瓶装</div>
					</template>
				</el-table-column>
				<el-table-column label="SKU标题颜色"  prop="skuColor" sortable>
					<template slot-scope="scope">
						<div class="color-box" :style="{ background: scope.row.skuColor }"></div>
					</template>
				</el-table-column>
				<el-table-column label="使用状态" sortable>
					<template slot-scope="scope">
						{{scope.row.userStatus==1?"停用":"正常"}}
					</template>
				</el-table-column>
				<el-table-column prop="defaultFlag" label="是否默认选项" sortable>
					<template slot-scope="scope">
						{{scope.row.defaultFlag==0?"否":"是"}}
					</template>
				</el-table-column>
				<el-table-column prop="remark" label="备注">
				</el-table-column>
			</el-table>
		</div>
		<skuEdit ref="skuEdit" @getList="getList"></skuEdit>
	</div>
</template>

<script>
	import skuEdit from './components/sku-edit.vue'
	import { hasPermission } from '@/utils/permission'
	export default {
		name:'skuManage',
		components: {
			skuEdit
		},
		data() {
			return {
				tableData: [],
				multipleSelection: [],
				height: 500,
				isEdit:false,
			}
		},
		created() {
			this.getList()
			if (this.$route.meta.perm) {
				this.isEdit = hasPermission(this.$route.meta.perm);
				// console.log(this.isEdit)
			}
		},
		mounted(){
			let height = this.$refs.tableHeight.offsetHeight;
			this.height = window.innerHeight -120- height;
		},
		methods: {
			tabRowClassName({
				row,
				rowIndex
			}) {
				let index = rowIndex + 1;
				if (index % 2 == 1) {
					return 'warning-row'
				}
			},
			cellStyle({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				if (columnIndex == 1) {
					return 'cursor: pointer;'
				}
			},
			// 新增sku
			handleAdd() {
				this.$refs.skuEdit.init()
			},
			// 新增/编辑
			handleEdit(row, column, cell, event) {
				if (column.label == 'SKU名称') {
					this.$refs.skuEdit.init(row)
				} else {
					this.$refs.multipleTable.toggleRowSelection(row);
				}
			},

			// 获取列表
			getList() {
				let that = this;
				that.$request.post(
						"skuList",
						true, {}
					)
					.then((res) => {
						if (res) {
							that.tableData = res.data
						}
					})
			},
			// 列多选
			handleSelectionChange(val) {
				console.log(val)
				this.multipleSelection = val;
			},
			// 删除
			deleteRow() {
				let that = this;
				if (that.multipleSelection.length <= 0) {
					this.$message.error('请先选择!');
					return
				}
				let skuIds = []
				that.multipleSelection.forEach(item => {
					skuIds.push(item.skuId)
				});
				that.$confirm('是否确认删除？', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'error'
				}).then(() => {
					that.$request.post(
							"skuDelete",
							false, {
								skuIds: skuIds,
							}
						)
						.then((res) => {
							if (res) {
								that.$message.success("删除成功！");
								that.getList()
							}
						})
				}).catch(() => {});
			},
			// 状态
			updateStatusRow(status) {
				let that = this;
				if (that.multipleSelection.length <= 0) {
					this.$message.error('请先选择!');
					return
				}
				let skuIds = []
				that.multipleSelection.forEach(item => {
					skuIds.push(item.skuId)
				});
				that.$request.post(
						"skuUpdateStatus",
						false, {
							skuIds: skuIds,
							userStatus: status
						}
					)
					.then((res) => {
						if (res) {
							// 0:正常;1:停用
							that.$message.success(status == 1 ? "已停用" : "已启用");
							that.getList()
						}
					})

			},
		},
	}

</script>

<style lang='scss' scoped>
	.container {
		background: #fff;
		box-sizing: border-box;
		margin: 12px 26px 15px 10px;

		// padding-bottom: 20px;
		.el-table {

			// 深度选择器，去除默认的padding
			/deep/ th {
				padding: 0px;
			}

			/deep/ td {
				padding: 5px;
			}

			/deep/ .warning-row {
				background: #F1F1F5;
			}
			/deep/ th .el-table__cell{
				padding: 0 !important;
			}
		}
	}

	.red {
		width: 50px;
		height: 20px;
		background: #D9001B;
	}

	.blue {
		width: 50px;
		height: 20px;
		background: #02A7F0;
	}

	.search-container {
		padding: 8px;
	}

	.color-box {
		width: 50px;
		height: 20px;
	}

</style>
